import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import CODE from "../../Static/Constants/StatusCodes";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import Loader from "../../Helper/Loaders/Loader";
import { getPagesMetaData } from "../../Api/Api";
import AppCache from "../../Helper/Common/AppCache";
import { decryptTheParams } from "../../Helper/QueryParams/EncryptDecrypt";
import ScreenContainer from "../../Components/ScreenContainer";
import CustomBMSAlertV2Main from "./CustomBMSAlertV2Main";

const buildCustomBMSMetaInfo = (apiMetaInfo, customConfig, activeTab) => {
  const tabConfig = customConfig?.[activeTab] || {};
  return {
    ...apiMetaInfo,
    filterConfigurations: {
      diagnosticsStateTable: {
        filters:
          tabConfig.lists?.faultList?.filters ??
          apiMetaInfo?.filterConfigurations?.diagnosticsStateTable?.filters ??
          [],
      },
    },
    customBMSConfig: customConfig || {},
    activeTabConfig: tabConfig,
  };
};

function CustomBMSAlertV2Page() {
  const [apiMetaInfo, setApiMetaInfo] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [pagesContent, setPagesContent] = useState({ mounted: false });
  const [fetchError, setFetchError] = useState(false);

  const customConfig = useMemo(
    () => AppCache.getItem("customObservabilityConfig")?.customBMSAlertV2 || {},
    []
  );

  useEffect(() => {
    if (!apiMetaInfo || !activeTab) return;
    setPagesContent({
      mounted: true,
      metaInfo: buildCustomBMSMetaInfo(apiMetaInfo, customConfig, activeTab),
    });
  }, [apiMetaInfo, activeTab, customConfig]);

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const res = await getPagesMetaData("bmsAlertV2");
        if (res?.responseStatus?.code === CODE.SUCCESS) {
          const meta = res.response?.response?.metaInfo || {};
          setApiMetaInfo(meta);
          const validTabs = customConfig.tabsToShow || ["activeFaults"];
          const urlParams = decryptTheParams();
          let urlTab = null;
          try { urlTab = urlParams.tab ? JSON.parse(urlParams.tab) : null; } catch {}
          const defaultTab = (urlTab && validTabs.includes(urlTab)) ? urlTab : (validTabs[0] || "activeFaults");
          setActiveTab(defaultTab);
        } else {
          setFetchError(true);
        }
      } catch {
        setFetchError(true);
      }
    };
    fetchMeta();
  }, [customConfig]);

  if (fetchError) {
    return (
      <Box
        sx={{
          height: "100vh",
          bgcolor: ThemeProperties.backgroundPurpleDarker,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="fw500s14lh20c686868">
          Failed to load page configuration. Please refresh and try again.
        </Typography>
      </Box>
    );
  }

  if (!pagesContent.mounted) {
    return (
      <Box sx={{ height: "100vh", bgcolor: ThemeProperties.backgroundPurpleDarker }}>
        <Loader />
      </Box>
    );
  }

  return (
    <ScreenContainer pagesContent={pagesContent}>
      <CustomBMSAlertV2Main
        customConfig={customConfig}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </ScreenContainer>
  );
}

export default CustomBMSAlertV2Page;
